import { gsap, ScrollTrigger } from "../global/gsap";

const initFilter = (filterEl) => {
    const body = document.querySelector('.js-body');
    const filterBtns = filterEl.querySelectorAll('.js-filter-btn');
    const filterGroups = filterEl.querySelectorAll('.js-filter-group');
    const dashboardBtns = filterEl.querySelectorAll('.js-dashboard-btn');
    const toggleBtn = document.querySelectorAll('.js-dashboard-toggle');
    const iframe = document.querySelector('.js-iframe');
    const themeLabel = document.querySelector('.js-dashboard-theme-label');
    const categoryBtn = document.querySelector('.js-category-btn');

    let activeBtn = filterEl.querySelector('.js-filter-btn.is-active');
    let activeGroup = filterEl.querySelector('.js-filter-group.is-active');
    let activeDashboardBtn = filterEl.querySelector('.js-dashboard-btn.is-active');
    let filterOpen = false;

    filterBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();

            if (activeBtn) activeBtn.classList.remove('is-active');
            if (activeGroup) activeGroup.classList.remove('is-active');

            const { index } = btn.dataset;
            const group = filterEl.querySelector(`.js-filter-group[data-index="${index}"]`);
            const { color} = btn.dataset;

            filterEl.style.setProperty('--theme-color', color);

            btn.classList.add('is-active');
            group?.classList.add('is-active');

            activeBtn = btn;
            activeGroup = group;
        });
    });

    toggleBtn.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            filterOpen = !filterOpen;

            if (filterOpen) {
                categoryBtn.innerHTML = '<span>Close</span> categories';
                body.classList.add('filter-active');
            } else {
                categoryBtn.innerHTML = '<span>Open</span> categories';
                body.classList.remove('filter-active');
            }
        });
    });

    const updateDashboard = (dashboard, slug) => {
        iframe.src = 'https://prior.hmd.dev/' + dashboard;

        if (activeDashboardBtn) activeDashboardBtn.classList.remove('is-active');

        const targetBtn = [...dashboardBtns].find(btn => btn.dataset.slug === slug);
        if (targetBtn) {
            targetBtn.classList.add('is-active');
            activeDashboardBtn = targetBtn;
        }
    };

    dashboardBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();

            let { dashboard } = btn.dataset;
            const { slug } = btn.dataset;
            const { color } = btn.dataset;
            const { name } = btn.dataset;

            if (!dashboard) { return; }

            updateDashboard(dashboard, slug);

            themeLabel.style.backgroundColor = color;
            themeLabel.textContent = name;

            history.pushState({ dashboard: dashboard, slug: slug }, "", slug);

            setTimeout(() => {
                categoryBtn.innerHTML = 'Open categories';
                body.classList.remove('filter-active');
                filterOpen = false;
            }, 300);
        });
    });

    window.addEventListener('popstate', (e) => {
        if (e.state && e.state.dashboard && e.state.slug) {
            updateDashboard(e.state.dashboard, e.state.slug);
        } else {
            location.reload();
        }
    });

};

export { initFilter as default };
